import { ValidationArgs } from "@vuelidate/core";

export class Validation<T> {
  rules: ValidationArgs<T>;
  scope = "";

  constructor(rules: ValidationArgs<T>, scope = "") {
    this.rules = rules;
    this.scope = scope;
  }
}
